export default function(array1, array2) {
  return (
    array1.length === array2.length &&
    array1.every((item, idx) => array2[idx] === item)
  )
}
